import React from 'react';
import styled from '@emotion/styled';
import { DELIVERY_INFO_MODS, WAREHOUSE_INFO_MODS, WAREHOUSE_TYPES } from '../../../../../config';
import { fetchDeleteWarehouse, fetchGetAdminWarehouse } from '../../../../../actions/admin';
import { toast } from 'react-toastify';
import { parseError } from '../../../../../helpers';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { showModal } from '../../../../../actions/modal';

const TableContainer = styled('div')`
  overflow-x: auto;
  overflow-y: auto;
  height: 500px;

  .form-control[type='checkbox'] {
    width: 16px;
    height: 16px;
  }

  .green-check {
    color: green;
    font-size: 24px;
  }

  tr {
    .action-icon {
      visibility: hidden;
      margin-left: 5px;
    }

    &:hover {
      .action-icon {
        visibility: initial;
        cursor: pointer;
      }
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
`;

const List = (props) => {
  const { values, handleSwitchMode } = props;
  const dispatch = useDispatch();

  const handleRemoveItem = (code) => {
    dispatch(fetchDeleteWarehouse(code))
      .then(() => {
        toast.info('Элемент был успешно удален');
        dispatch(fetchGetAdminWarehouse());
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  useEffect(() => {
    dispatch(fetchGetAdminWarehouse());
  }, []);

  const handleConfirmDeleteItem = (item) => {
    dispatch(
      showModal('ConfirmDelete', {
        body: item.title,
        image: item.imgUrl,
        handleConfirm: () => handleRemoveItem(item.code),
      }),
    );
  };

  const defineOperatorType = (outerItem) => {
    return WAREHOUSE_TYPES.find((item) => item.value === outerItem)?.label || null;
  };

  return (
    <TableContainer>
      <div className="fixed-table-container">
        <div className="fixed-table-body">
          <table className="table table-centered">
            <thead className="thead-light">
              <tr>
                <th style={{ minWidth: '65px', maxWidth: '65px' }} />
                <th style={{ minWidth: '95px', maxWidth: '95px' }}>По умолчанию</th>
                <th style={{ minWidth: '135px', maxWidth: '135px' }}>Название склада</th>
                {/*                <th style={{ minWidth: '200px', maxWidth: '200px' }}>Адрес</th>*/}

                <th style={{ minWidth: '95px', maxWidth: '95px' }}>Тип склада</th>
                {/*                <th style={{ minWidth: '95px', maxWidth: '95px' }}>Тип ФФ</th>*/}
                <th style={{ minWidth: '95px', maxWidth: '95px' }}>География склада</th>
                {/*                <th style={{ minWidth: '95px', maxWidth: '95px' }}>Тип операций</th>*/}
              </tr>
            </thead>
            <tbody>
              {values.warehouses.map((item, index) => (
                <tr key={index}>
                  <td style={{ minWidth: '65px', maxWidth: '65px' }}>
                    <section className="correction-data">
                      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '8px' }}>
                        <i
                          className="fe-edit edit-icon action-icon"
                          onClick={() => handleSwitchMode(WAREHOUSE_INFO_MODS.EDIT, item)}
                          title="Изменить"
                        />
                        <i
                          className="fe-trash edit-icon action-icon"
                          onClick={() => handleConfirmDeleteItem(item)}
                          title="Удалить"
                        />
                      </div>
                    </section>
                  </td>
                  <td style={{ minWidth: '95px', maxWidth: '95px' }}>
                    {item.isDefault && <i className="fe-check green-check" />}
                  </td>
                  <td style={{ minWidth: '135px', maxWidth: '135px' }}>
                    {item.title ? item.title : null}
                  </td>
                  {/*                  <td style={{ minWidth: '200px', maxWidth: '200px' }}>
                    {item.address ? item.address.fullAddress : null}
                  </td>*/}
                  <td style={{ minWidth: '95px', maxWidth: '95px' }}>
                    {item.operatorType ? defineOperatorType(item.operatorType) : null}
                  </td>
                  {/*                  <td style={{ minWidth: '95px', maxWidth: '95px' }}>
                    {item.fulfillmentType ? item.fulfillmentType : null}
                  </td>*/}
                  <td style={{ minWidth: '95px', maxWidth: '95px' }}>
                    {item.fulfillmentSubTypeTitle ? item.fulfillmentSubTypeTitle : null}
                  </td>
                  {/*                  <td style={{ minWidth: '95px', maxWidth: '95px' }}>
                    {item.operationType ? item.operationType : null}
                  </td>*/}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </TableContainer>
  );
};

export default List;
